export default __webpack_public_path__ + "static/media/fireflink.0d427889.svg";